import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getSharedHomeworks } from "../../../api/endpoints/HomeworkEndpoints";
import { Paged } from "../../../models/Paged";
import {
  SharedHomework,
  SharedHomeworkRequest,
} from "../../../models/SharedHomework";

export default function useGetSharedHomeworksPaginated() {
  return useMutation<Paged<SharedHomework>, AxiosError, SharedHomeworkRequest>({
    mutationKey: ["shared-homeworks"],
    mutationFn: (sharedHomeworkRequest) =>
      getSharedHomeworks(sharedHomeworkRequest),
  });
}
